import type { MouseEvent } from 'react';
import { Icon, type IconName } from '../ui/Icon.tsx';

// Kop boven een open mail op de telefoon (48 px): links Terug naar de lijst, rechts de acties die
// Jeroen het meest gebruikt (Beantwoorden, Archiveren, Vlag) en Meer, dat het actievel met alle
// acties opent. Alle knoppen zijn 44 × 44 px; de werkbalk met tien iconen van de lezer blijft hier weg.

export function PhoneReaderBar(props: { flagged: boolean; isDraft?: boolean | undefined; onBack: () => void; onReply: () => void; onArchive: () => void; onFlag: () => void; onMore: (x: number, y: number) => void }) {
  const more = (e: MouseEvent<HTMLButtonElement>) => {
    const r = e.currentTarget.getBoundingClientRect();
    props.onMore(r.right, r.bottom);
  };
  return (
    <div className="h-12 shrink-0 flex items-center gap-0.5 px-1 border-b border-line bg-surface" role="toolbar" aria-label="Mail">
      <button type="button" aria-label="Terug naar de lijst" onClick={props.onBack} className="h-11 pl-1 pr-3 inline-flex items-center gap-0.5 rounded-md text-[15px] font-medium text-accent active:bg-tint">
        <Icon name="chevron" size={20} className="rotate-180" /> Terug
      </button>
      <span className="flex-1" />
      {!props.isDraft ? <Action icon="reply" label="Beantwoorden" onClick={props.onReply} /> : null}
      <Action icon="archive" label="Archiveren" onClick={props.onArchive} />
      <Action icon="flag" label={props.flagged ? 'Vlag weg' : 'Vlaggen'} active={props.flagged} onClick={props.onFlag} />
      <Action icon="more" label="Meer acties" onClick={more} />
    </div>
  );
}

function Action(props: { icon: IconName; label: string; active?: boolean | undefined; onClick: (e: MouseEvent<HTMLButtonElement>) => void }) {
  return (
    <button type="button" aria-label={props.label} title={props.label} aria-pressed={props.active} onClick={props.onClick} className={`h-11 w-11 shrink-0 inline-flex items-center justify-center rounded-md active:bg-tint ${props.active ? 'text-red' : 'text-ink-soft'}`}>
      <Icon name={props.icon} size={22} />
    </button>
  );
}
